import {memo} from 'react';

import type {SVGProps} from 'react';

export const BuildingIcon = memo(function BuildingIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g fill="none">
        <g>
          <path
            d="M18.3327 7.50008H13.7493V5.04175C13.7493 4.58341 13.3743 4.16675 12.8743 4.16675H5.04102C4.58268 4.16675 4.16602 4.54175 4.16602 5.04175V13.7501H3.79102C3.29102 13.7501 2.91602 14.1251 2.91602 14.6251V18.3334C2.91602 18.7917 3.29102 19.1667 3.79102 19.1667H14.166C14.166 19.1667 14.166 19.1667 14.2077 19.1667H19.2077C19.666 19.1667 20.041 18.7917 20.041 18.3334V9.16675C19.9993 8.25008 19.2493 7.50008 18.3327 7.50008Z"
            fill="var(--icon-fill-purple)"
          />
          <path
            d="M15 9.16675V8.33341C15 8.08341 15.1667 7.91675 15.4167 7.91675H16.25C16.5 7.91675 16.6667 8.08341 16.6667 8.33341V9.16675C16.6667 9.41675 16.5 9.58341 16.25 9.58341H15.4167C15.1667 9.58341 15 9.41675 15 9.16675ZM15.4167 12.5001H16.25C16.5 12.5001 16.6667 12.3334 16.6667 12.0834V11.2501C16.6667 11.0001 16.5 10.8334 16.25 10.8334H15.4167C15.1667 10.8334 15 11.0001 15 11.2501V12.0834C15 12.3334 15.1667 12.5001 15.4167 12.5001ZM15.4167 15.4167H16.25C16.5 15.4167 16.6667 15.2501 16.6667 15.0001V14.1667C16.6667 13.9167 16.5 13.7501 16.25 13.7501H15.4167C15.1667 13.7501 15 13.9167 15 14.1667V15.0001C15 15.2501 15.1667 15.4167 15.4167 15.4167Z"
            fill="var(--icon-stroke-purple)"
          />
          <path
            d="M6.25 12.4999H5.41667C5.16667 12.4999 5 12.3333 5 12.0833V11.2499C5 10.9999 5.16667 10.8333 5.41667 10.8333H6.25C6.5 10.8333 6.66667 10.9999 6.66667 11.2499V12.0833C6.66667 12.3333 6.5 12.4999 6.25 12.4999Z"
            fill="var(--icon-stroke-purple)"
          />
          <path
            d="M5.00065 15V14.1667C5.00065 13.9167 4.83398 13.75 4.58398 13.75H3.75065C3.50065 13.75 3.33398 13.9167 3.33398 14.1667V15C3.33398 15.25 3.50065 15.4167 3.75065 15.4167H4.58398C4.83398 15.4167 5.00065 15.25 5.00065 15Z"
            fill="var(--icon-stroke-purple)"
          />
          <path
            d="M9.58268 12.0833V11.2499C9.58268 10.9999 9.41602 10.8333 9.16602 10.8333H8.33268C8.08268 10.8333 7.91602 10.9999 7.91602 11.2499V12.0833C7.91602 12.3333 8.08268 12.4999 8.33268 12.4999H9.16602C9.41602 12.4999 9.58268 12.3333 9.58268 12.0833Z"
            fill="var(--icon-stroke-purple)"
          />
          <path
            d="M6.66667 9.16675V8.33341C6.66667 8.08341 6.5 7.91675 6.25 7.91675H5.41667C5.16667 7.91675 5 8.08341 5 8.33341V9.16675C5 9.41675 5.16667 9.58341 5.41667 9.58341H6.25C6.5 9.58341 6.66667 9.41675 6.66667 9.16675Z"
            fill="var(--icon-stroke-purple)"
          />
          <path
            d="M9.58268 9.16675V8.33341C9.58268 8.08341 9.41602 7.91675 9.16602 7.91675H8.33268C8.08268 7.91675 7.91602 8.08341 7.91602 8.33341V9.16675C7.91602 9.41675 8.08268 9.58341 8.33268 9.58341H9.16602C9.41602 9.58341 9.58268 9.41675 9.58268 9.16675Z"
            fill="var(--icon-stroke-purple)"
          />
          <path
            d="M6.66667 6.25V5.41667C6.66667 5.16667 6.5 5 6.25 5H5.41667C5.16667 5 5 5.16667 5 5.41667V6.25C5 6.5 5.16667 6.66667 5.41667 6.66667H6.25C6.5 6.66667 6.66667 6.5 6.66667 6.25Z"
            fill="var(--icon-stroke-purple)"
          />
          <path
            d="M9.58268 6.25V5.41667C9.58268 5.16667 9.41602 5 9.16602 5H8.33268C8.08268 5 7.91602 5.16667 7.91602 5.41667V6.25C7.91602 6.5 8.08268 6.66667 8.33268 6.66667H9.16602C9.41602 6.66667 9.58268 6.5 9.58268 6.25Z"
            fill="var(--icon-stroke-purple)"
          />
          <path
            d="M11.2507 15V14.1667C11.2507 13.9167 11.084 13.75 10.834 13.75H10.0007C9.75065 13.75 9.58398 13.9167 9.58398 14.1667V15C9.58398 15.25 9.75065 15.4167 10.0007 15.4167H10.834C11.084 15.4167 11.2507 15.25 11.2507 15Z"
            fill="var(--icon-stroke-purple)"
          />
          <path
            d="M8.33333 17.2917V14.1667C8.33333 13.9167 8.16667 13.75 7.91667 13.75H6.66667C6.41667 13.75 6.25 13.9167 6.25 14.1667V17.2917H8.33333Z"
            fill="var(--icon-stroke-purple)"
          />
          <path
            d="M1.875 2.70825H12.7083"
            stroke="var(--icon-stroke-purple)"
            strokeWidth={1.25}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M13.125 13.4166V12.7083C13.125 12.2499 12.75 11.8749 12.2917 11.8749H11.875V2.70825"
            stroke="var(--icon-stroke-purple)"
            strokeWidth={1.25}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M2.70898 9.25V11.875H2.29232C1.83398 11.875 1.45898 12.25 1.45898 12.7083V16.4583C1.45898 16.9167 1.83398 17.2917 2.29232 17.2917H12.2923C12.7507 17.2917 13.1257 16.9167 13.1257 16.4583V15.6667"
            stroke="var(--icon-stroke-purple)"
            strokeWidth={1.25}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M2.70898 2.70825V5.99992"
            stroke="var(--icon-stroke-purple)"
            strokeWidth={1.25}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M14.791 5.625H16.8743C17.791 5.625 18.541 6.375 18.541 7.29167V16.4583C18.541 16.9167 18.166 17.2917 17.7077 17.2917H15.666"
            stroke="var(--icon-stroke-purple)"
            strokeWidth={1.25}
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
    </svg>
  );
});
